<template>
  <div>
    <CustomerInfoAddNew :isSidebarInfoActive="addNewInfoDataSidebar" :data="infoData" />
    <EmployeeAddNew
      :isPromptActiveEmployee="isPromptActiveEmployeeLocal"
      :data="infoData"
    />
    <CustomerActAddNew
      :isSidebarActive="addNewActSidebar"
      @closeSidebar="toggleActSidebar"
      :data="infoData"
    />
    <vs-card>
      <b-row align-h="start">
        <b-col md="auto" style="width: auto">
          <b-button
            style="border-color: white"
            v-on:click="addCustomerAct()"
            class="bg-primary vs-con-loading__container"
            id="loading-customer-move"
          >
            <Icon
              icon="ant-design:product-filled"
              style="margin-right: 5px"
              width="20"
              height="20"
            />{{ $t("CustomerAct") }}
          </b-button>
        </b-col>
        <b-col md="auto" style="width: auto">
          <b-button
            style="border-color: white"
            v-on:click="addInfoData()"
            class="bg-primary vs-con-loading__container"
            id="loading-marketplace-list"
          >
            <Icon
              icon="icon-park-outline:view-grid-detail"
              style="margin-right: 5px"
              width="20"
              height="20"
            />{{ $t("Marketplace") }}
          </b-button>
        </b-col>
        <!--
        <b-col cols="3" md="auto" style="padding-right: 2px">
          <b-button
            class="bg-primary"
            style="border-color: white"
            v-on:click="addEmployeeData()"
          >
            <Icon
              icon="clarity:employee-line"
              style="margin-right: 5px"
              width="20"
              height="20"
            />{{ $t("EmployeeId") }}
          </b-button>
        </b-col>-->
      </b-row>
    </vs-card>
    <vs-card>
      <ag-grid-vue
        ref="agGridTable"
        class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
        :columnDefs="columns"
        :defaultColDef="defaultColDef"
        :rowData="processList"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        @grid-ready="onGridReady"
        :suppressCopyRowsToClipboard="true"
        :localeText="localeText"
        :suppressRowClickSelection="true"
        @first-data-rendered="onFirstDataRendered"
      >
      </ag-grid-vue>
    </vs-card>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Icon } from "@iconify/vue2";
import i18nData from "../../i18n/i18nData";
import CustomerActListTransferType from "./CellRenderers/CustomerActListTransferType.vue";
import detailBtnCellRenderer from "../CellRenderers/detailBtnCellRenderer.vue";
import CustomerActAddNew from "./CustomerActAddNew.vue";
import EmployeeAddNew from "./EmployeeAddNew.vue";
import CustomerInfoAddNew from "./CustomerInfoAddNew.vue";
import moment from "moment";
export default {
  data() {
    return {
      addNewInfoDataSidebar: false,
      isPromptActiveEmployeeLocal: false,
      addNewActSidebar: false,
      infoData: [],
      processList: [],
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      columns: [],
    };
  },
  components: {
    EmployeeAddNew,
    CustomerInfoAddNew,
    CustomerActAddNew,
    detailBtnCellRenderer,
    CustomerActListTransferType,
    AgGridVue,
    Icon,
  },
  methods: {
    closeInfoData() {
      this.addNewInfoDataSidebar = false;
    },
    closeEmployeeData() {
      this.isPromptActiveEmployeeLocal = false;
    },
    customerInfoDetail() {
      this.addNewInfoDataSidebar = true;
    },
    customerActDetail() {
      this.addNewActSidebar = true;
    },

    employeeDetail() {
      this.isPromptActiveEmployeeLocal = true;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    toggleActSidebar(val = false) {
      this.addNewActSidebar = val;
    },
    getEmployeeColumnList() {
      this.columns = [];
      if (this.processList.length > 0) {
        let columnList = Object.keys(this.processList[0]);
        this.columns.push({
          width: 70,
          pinned: "left",
          cellRendererFramework: "detailBtnCellRenderer",
          cellRendererParams: {
            detailMethods: "employeeDetail",
            iconDetail: "material-symbols:edit",
            iconColor: "#065a82",
          },
        });
        columnList.forEach((val, index) => {
          if (val == "CompanyName") {
            this.columns.push({
              pinned: "left",
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          } else if (val.toString().includes("Date") == true)
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              valueFormatter: (params) => this.parseDate(params.data[val]),
              editable: true,
            });
          else if (val.toString().includes("Id") == false) {
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          }
        });
      }
    },
    parseDate(params) {
      return moment(String(params)).format("DD.MM.YYYY");
    },
    getCustomerInfoColumnList() {
      this.columns = [];
      if (this.processList.length > 0) {
        let columnList = Object.keys(this.processList[0]);
        this.columns.push({
          width: 70,
          pinned: "left",
          cellRendererFramework: "detailBtnCellRenderer",
          cellRendererParams: {
            detailMethods: "customerInfoDetail",
            iconDetail: "material-symbols:edit",
            iconColor: "#065a82",
          },
        });
        columnList.forEach((val, index) => {
          if (val == "CompanyName") {
            this.columns.push({
              pinned: "left",
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          } else if (val == "CompanyTransType") {
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              cellRendererFramework: "CustomerActListTransferType",
            });
          } else if (val.toString().includes("Date") == true)
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              valueFormatter: (params) => this.parseDate(params.data[val]),
              editable: true,
            });
          else if (
            val.toString().includes("Id") == false &&
            val.toString().includes("InfoType") == false
          )
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
        });
      }
    },
    getCustomerActColumnList() {
      this.columns = [];
      if (this.processList.length > 0) {
        let columnList = Object.keys(this.processList[0]);
        this.columns.push({
          width: 100,
          pinned: "left",
          cellRendererFramework: "detailBtnCellRenderer",
          cellRendererParams: {
            detailMethods: "customerActDetail",
            iconDetail: "material-symbols:edit",
            iconColor: "#065a82",
          },
        });
        columnList.forEach((val, index) => {
          if (val == "CompanyName") {
            this.columns.push({
              pinned: "left",
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          } else if (val.toString().includes("Date") == true)
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              valueFormatter: (params) => this.parseDate(params.data[val]),
              editable: true,
            });
          else if (val.toString().includes("Id") == false) {
            this.columns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          }
        });
      }
    },
    addEmployeeData() {
      const vs = this.$vs;

      this.$store
        .dispatch("customer/listEmployee")
        .then((response) => {
          if (response.success == true) {
            try {
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    addInfoData() {
      const vs = this.$vs;
      let type = "material";

      vs.loading({
        container: `#loading-marketplace-list`,
        type,
        scale: 0.5,
      });
      this.$store
        .dispatch("customer/listCustomerInfo")
        .then((response) => {
          if (response.success == true) {
            setTimeout(() => {
              vs.loading.close("#loading-marketplace-list > .con-vs-loading");
            }, 1000);
            try {
            } catch (error) {
              console.log(error);
            }
          } else {
            setTimeout(() => {
              vs.loading.close("#loading-marketplace-list > .con-vs-loading");
            }, 1000);
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        })
        .catch((error) => {
          setTimeout(() => {
            vs.loading.close("#loading-marketplace-list > .con-vs-loading");
          }, 1000);
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    addCustomerAct() {
      const vs = this.$vs;
      let type = "material";

      vs.loading({
        container: `#loading-customer-move`,
        type,
        scale: 0.5,
      });
      this.$store
        .dispatch("customer/listCustomerAct")
        .then((response) => {
          if (response.success == true) {
            setTimeout(() => {
              vs.loading.close("#loading-customer-move > .con-vs-loading");
            }, 1000);
            try {
            } catch (error) {
              console.log(error);
            }
          } else {
            setTimeout(() => {
              vs.loading.close("#loading-customer-move > .con-vs-loading");
            }, 1000);
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        })
        .catch((error) => {
          setTimeout(() => {
            vs.loading.close("#loading-customer-move > .con-vs-loading");
          }, 1000);
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      var defaultSortModel = [{ colId: "CompanyName", sort: "asc", sortIndex: 0 }];
      params.columnApi.applyColumnState({ state: defaultSortModel });
      this.gridApi.refreshCells(params);
    },
  },
  computed: {
    employeeAll: {
      get() {
        return this.$store.state.customer.EmployeeAll;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    customerInfoAll: {
      get() {
        return this.$store.state.customer.CustomerInfoAllList;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    customerActAll: {
      get() {
        return this.$store.state.customer.CustomerActAll;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    localeText() {
      return i18nData[this.$i18n.locale];
    },
  },
  mounted() {
    this.$root.$on("employeeDetail", (data) => {
      this.infoData = data;
      this.employeeDetail(data);
    });
    this.$root.$on("customerInfoDetail", (data) => {
      this.infoData = data;

      this.customerInfoDetail(data);
    });
    this.$root.$on("customerActDetail", (data) => {
      this.infoData = data;

      this.customerActDetail(data);
    });
    this.$root.$on("closeInfoData", () => {
      this.closeInfoData();
    });
    this.$root.$on("closeEmployeeData", () => {
      this.closeEmployeeData();
    });
  },
  beforeDestroy() {
    this.$root.$off("employeeDetail");
    this.$root.$off("customerInfoDetail");
    this.$root.$off("customerActDetail");
    this.$root.$off("closeInfoData");
    this.$root.$off("closeEmployeeData");
  },
  watch: {
    employeeAll(val) {
      if (val.length > 0) {
        this.processList = val;
        this.getEmployeeColumnList();
      }
      return val;
    },
    customerInfoAll(val) {
      if (val.length > 0) {
        this.processList = val;
        this.getCustomerInfoColumnList();
      }

      return val;
    },
    customerActAll(val) {
      if (val.length > 0) {
        this.processList = val;
        this.getCustomerActColumnList();
      }

      return val;
    },
  },
};
</script>
<style lang="scss" scoped>
.scroll-to-ag-grid-table {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 190px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
